export default __webpack_public_path__ + "static/media/ACCOMMODATIONS_ATTRACTIONS.6881bfff.png";